import { render, staticRenderFns } from "./CheckoutPnrInfoBadge.vue?vue&type=template&id=73f27b26&scoped=true"
import script from "./CheckoutPnrInfoBadge.vue?vue&type=script&lang=js"
export * from "./CheckoutPnrInfoBadge.vue?vue&type=script&lang=js"
import style0 from "./CheckoutPnrInfoBadge.vue?vue&type=style&index=0&id=73f27b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f27b26",
  null
  
)

export default component.exports